module.exports = __webpack_public_path__ + "img/chikuho2.4af8283d.jpg";